import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import "../ducks/index.js";
import { getAsyncRequestStatus } from "@ane/core/lib/models";
import DataSourceResource from "../../../DataSource.resource.js";
import { DataSourceListUserContextParam } from "../../../../models/DataSourceListUserContextParams.js";
import { setUserContextFunc, DataSourceListConstants } from "../ducks/DataSourceListFilter.ducks.js";
import { matchesRootPathname } from "@ane/exp-data/lib/routes/Route.utils";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { DataSourceRouteUtils } from "@ane/exp-data/lib/routes/DataSourceRoute.utils";
import { dataSourceListActionTypes, dataSourceListLoadingAction, dataSourceListLoadedAction } from "../ducks/DataSourceList.ducks.js";
const loadDataSourceListArgs = {
  filterOnType: dataSourceListActionTypes.LOAD,
  loadResource: (payload, state) => {
    return DataSourceResource.getDataSourceList(payload.workspaceId, payload.search, payload.dataSourceType);
  },
  loadingAction: dataSourceListLoadingAction,
  loadedAction: (successData, payload, error) => {
    const result = {
      status: getAsyncRequestStatus(error || ""),
      data: successData,
      error
    };
    return of(dataSourceListLoadedAction(payload, result));
  }
};
const loadDataSourceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceListArgs);
const provideDataSourceListEpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    DataSourceListUserContextParam,
    setUserContextFunc,
    DataSourceListConstants.SET_PARTIAL_USER_CONTEXT,
    DataSourceListConstants.SET_USER_CONTEXT,
    (store) => store.dataSourceManagementModule.dataSourceListState.userContext,
    history,
    (pathname) => {
      return !matchesRootPathname(pathname, DataSourceRouteUtils.routes.view.path()) && matchesRootPathname(pathname, DataSourceRouteUtils.routes.list.path());
    },
    EXP_QUERY_STRINGS
  );
  const dataSourceListEpics = combineEpics(loadDataSourceEpic, ...Object.values(setUserContextFromRouteQueryString));
  return dataSourceListEpics;
};
export {
  loadDataSourceEpic,
  provideDataSourceListEpics
};
//# sourceMappingURL=DataSourceListEpic.js.map
